import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LangService, { LangNames } from './LangService'
import criticalEn from './en/criticalEn'
import criticalRu from './ru/criticalRu'

// В главный бандл попадают только разделы словаря, нужные до первого рендера
// (страницы авторизации и названия страниц). Остальное подгружается
// динамически — см. loadRestTranslations.
i18next.use(initReactI18next).init({
	resources: {
		en: {
			translation: criticalEn,
		},
		ru: {
			translation: criticalRu,
		},
	},
	lng: LangService.getCurrentLangFromLocalStorage(),
	fallbackLng: LangNames.RU,
	react: {
		// Перерисовать компоненты, когда догрузится основная часть словаря
		bindI18nStore: 'added',
	},
	// debug: true,
})
